import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformProjectBookmarks } from './project-bookmarks.transformers';
import { ProjectBookmarksCollection } from './project-bookmarks.types';

export function projectBookmarksReducer(
  state: CollectionStateSlice<ProjectBookmarksCollection> = {},
  action: CollectionActions<ProjectBookmarksCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'projectBookmarks') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<ProjectBookmarksCollection>(
          state,
          transformIntoDocuments([result], transformProjectBookmarks),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'projectBookmarks') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<ProjectBookmarksCollection>(
          state,
          transformIntoDocuments([result], transformProjectBookmarks),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
